import {
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import * as _ from 'lodash';
import { IconsPipe } from '../../../helpers/pipes/icons.pipe';
import { Translator } from 'angular-translator';

interface ProductSearch {
  id: string;
  provider: string;
  name: string;
  section: string;
}

interface GroupedItems {
  group: string;
  items: ProductSearch[];
}

@Component({
  selector: 'product-provider-list',
  templateUrl: './product-provider-list.component.html',
  styleUrls: ['./product-provider-list.component.css'],
  providers: [IconsPipe],
})
export class ProductProviderListComponent implements OnDestroy {
  _products: ProductSearch[];
  providers: string[];
  groupedProducts: _.Dictionary<ProductSearch[]>;
  selectedProductId: string = null;

  @Input() set products(products: ProductSearch[]) {
    this._products = products;
    this.groupedProducts = _.groupBy(this._products, 'provider');
    const providers = Object.keys(this.groupedProducts);
    this.providers = _.orderBy(providers, provider => provider.toLowerCase(), ['asc']);
    this.selectedProductId = null;
    this.onSelect.emit(null);
  }

  get products(): ProductSearch[] {
    return this._products;
  }

  @Output() onSelect: EventEmitter<ProductSearch> = new EventEmitter<ProductSearch>();

  constructor(private translator: Translator) {

  }

  ngOnDestroy() {
    this.onSelect.emit(null);
  }

  selectProduct(product: ProductSearch) {
    this.selectedProductId = product.id;
    this.onSelect.emit(product);
  }


  getIconTooltipByProductType(type: string) {
    const tooltipMapping = {
      'Online': this.translator.instant('DISPONIBLE_ONLINE'),
      'Offline':  this.translator.instant('DISPONIBLE_OFFLINE'),
      'Batch':  this.translator.instant('DISPONIBLE_BATCH'),
    };
    return tooltipMapping[type] || '';
  }
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product-search/components/product-provider-list.component.ts